<p-confirmDialog key="confirmremove" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="setschedule" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Set Up Calendar-->
<div>
	<h2 style="text-align: center; font-weight: bold">Create a Schedule</h2>

	<!--Schedule Type-->
	<div class="ScheduleTypeDiv">
		<label>Schedule Type:</label>
		<div class="RadioGrid6Col">
			<input [disabled]="IsLoading() == true" id="DayOfWeek" type="radio" class="RAD" name="ScheduleTypeID" [(ngModel)]="ScheduleTypeID" [value]="1" />
			<label for="DayOfWeek">By Day of Week</label>

			<input
				[disabled]="IsLoading() == true"
				id="Alternating"
				type="radio"
				class="RAD LeftMargin"
				name="ScheduleTypeID"
				[(ngModel)]="ScheduleTypeID"
				[value]="2"
			/>
			<label for="Alternating">A Day, B Day</label>

			<input
				[disabled]="IsLoading() == true"
				id="Same"
				type="radio"
				class="RAD LeftMargin"
				name="ScheduleTypeID"
				[(ngModel)]="ScheduleTypeID"
				[value]="0"
			/>
			<label for="Same">All the Same</label>
		</div>
	</div>

	<!--Set up Days-->
	<div>
		<!--Day of Week-->
		<div *ngIf="ScheduleTypeID == 1" class="TemplateMainBorder">
			<h4 style="text-align: center">Daily Schedule:</h4>

			<div class="TemplateGroupDiv">
				<div *ngFor="let x of lstDayOfWeek" class="TemplateItemDiv">
					<h4 [style.color]="x.IsWeekend == false ? 'black' : 'orangered'">{{ x.Desc }}</h4>
					<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="x.DayID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstSchoolDay" [ngValue]="o.DayID">{{ o.DayDesc }}</option>
					</select>

					<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="x.BellScheduleID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstBellSchedule" [ngValue]="o.BellScheduleID">{{ o.BellScheduleDesc }}</option>
					</select>

					<select [disabled]="IsLoading() == true" class="form-control" [style.color]="x.OpenID != 0 ? 'black' : 'orangered'" [(ngModel)]="x.OpenID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstOpen" [ngValue]="o.ID" [style.color]="o.ID != 0 ? 'black' : 'orangered'">{{ o.Desc }}</option>
					</select>
				</div>
			</div>
		</div>

		<!--Alternating-->
		<div *ngIf="ScheduleTypeID == 2" class="TemplateMainBorder">
			<!--Templates-->
			<h4 style="text-align: center">Alternating Schedule:</h4>

			<div class="TemplateGroupDiv" style="justify-content: center; min-height: 201px">
				<div *ngFor="let x of lstAlternating" class="TemplateItemDiv">
					<h4>{{ x.Desc }}</h4>
					<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="x.DayID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstSchoolDay" [ngValue]="o.DayID">{{ o.DayDesc }}</option>
					</select>

					<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="x.BellScheduleID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstBellSchedule" [ngValue]="o.BellScheduleID">{{ o.BellScheduleDesc }}</option>
					</select>

					<select [disabled]="IsLoading() == true" class="form-control" [style.color]="x.OpenID != 0 ? 'black' : 'orangered'" [(ngModel)]="x.OpenID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstOpen" [ngValue]="o.ID" [style.color]="o.ID != 0 ? 'black' : 'orangered'">{{ o.Desc }}</option>
					</select>

					<button class="btn btn-danger RemoveButton" (click)="onRemoveDay(x)"><i class="fa fa-times" aria-hidden="true"></i></button>
				</div>

				<div *ngIf="lstAlternating.length == 0" style="height: 191px; align-items: center; display: grid">
					<label>...Add a day to the schedule</label>
				</div>
			</div>

			<!--Bottom Bar-->
			<div class="Buttons">
				<button class="btn btn-success" (click)="onAddDay()">Add Day</button>
				<button class="btn btn-danger" style="margin-left: 5px" (click)="onDeleteAllDays()">Delete All</button>
				<div class="WeekendOptionDiv">
					<label>Closed on Weekends:</label>
					<input
						[disabled]="IsLoading() == true"
						type="checkbox"
						class="CHK"
						[(ngModel)]="ClosedWeekends"
						(ngModelChange)="onClosedOnWeekendChange($event)"
					/>

					<label>Starting with:</label>
					<select
						[disabled]="IsLoading() == true"
						class="form-control"
						name="StartingDay"
						[(ngModel)]="StartingDay"
						(ngModelChange)="onStartingDayChange($event)"
					>
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstAlternating" [ngValue]="o">{{ o.Desc }}</option>
					</select>
				</div>
			</div>
		</div>

		<!--Same-->
		<div *ngIf="ScheduleTypeID == 0" class="TemplateMainBorder">
			<h4 style="text-align: center">Every Day Schedule:</h4>

			<div class="SameOptionDiv">
				<label>School Day:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Same_DayID" [(ngModel)]="Same_DayID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstSchoolDay" [ngValue]="o.DayID">{{ o.DayDesc }}</option>
				</select>

				<label>Bell Schedule:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Same_BellScheduleID" [(ngModel)]="Same_BellScheduleID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstBellSchedule" [ngValue]="o.BellScheduleID">{{ o.BellScheduleDesc }}</option>
				</select>

				<label>Open:</label>
				<select
					[disabled]="IsLoading() == true"
					class="form-control"
					name="Same_OpenID"
					[style.color]="Same_OpenID != 0 ? 'black' : 'orangered'"
					[(ngModel)]="Same_OpenID"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstOpen" [ngValue]="o.ID" [style.color]="o.ID != 0 ? 'black' : 'orangered'">{{ o.Desc }}</option>
				</select>

				<label>Closed on Weekends:</label>
				<input type="checkbox" class="CHK" [(ngModel)]="ClosedWeekends" (ngModelChange)="onClosedOnWeekendChange($event)" />
			</div>
		</div>
	</div>
</div>

<!--Date Options-->
<h2 class="ExtraTopMargin" style="text-align: center; font-weight: bold">Pick Date Range to Update</h2>

<!--Date Mode-->
<div class="DateModeDiv">
	<div class="DateModeGrid2Col">
		<label>Update By:</label>
		<div class="RadioGrid4Col">
			<input [disabled]="IsLoading() == true" id="Month" type="radio" class="RAD" name="DateModeID" [(ngModel)]="DateModeID" [value]="0" />
			<label for="Month">Month</label>

			<input [disabled]="IsLoading() == true" id="Semester" type="radio" class="RAD LeftMargin" name="DateModeID" [(ngModel)]="DateModeID" [value]="1" />
			<label for="Semester">Semester/School Year</label>
		</div>
	</div>

	<!--Month Mode-->
	<div *ngIf="DateModeID == 0" class="TopMargin DateModeMonthGrid">
		<label>Starting On:</label>
		<div>
			<p-calendar
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="OffsetStartDate"
				name="OffsetStartDate"
				[minDate]="OffsetMinDate"
				[maxDate]="OffsetMaxDate"
				(ngModelChange)="onOffsetStartDateChange($event)"
			></p-calendar>

			<label *ngIf="ScheduleTypeID == 2">{{ StartingDayDesc }}</label>
		</div>

		<label>Start Month:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="StartMonthYear"
			[(ngModel)]="StartMonthYear"
			[style.color]="StartMonthYear == null || StartMonthYear.NextColor == null ? 'Black' : StartMonthYear.NextColor"
			(ngModelChange)="onStartMonthYearChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstMonthYear" [ngValue]="o" [style.color]="o.NextColor">{{ o.Desc }}</option>
		</select>

		<label>End Month:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="EndMonthYear"
			[(ngModel)]="EndMonthYear"
			[style.color]="EndMonthYear == null || EndMonthYear.NextColor == null ? 'Black' : EndMonthYear.NextColor"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstMonthYear" [ngValue]="o" [style.color]="o.NextColor">{{ o.Desc }}</option>
		</select>
	</div>

	<!--Semester/Year Mode-->
	<div *ngIf="DateModeID == 1" class="TopMargin SemesterSelectDiv">
		<label>Semesters:</label>
		<p-listbox
			[options]="lstSemester"
			[(ngModel)]="SchoolYearSemesters"
			optionLabel="Semester"
			[metaKeySelection]="false"
			[checkbox]="true"
			[filter]="true"
			[multiple]="true"
			[listStyle]="{ 'max-height': '250px' }"
		>
			<ng-template let-SemesterItem pTemplate="item">
				<div class="SemesterItemDiv">
					<label>{{ SemesterItem.Semester }}</label>
					<p>({{ SemesterItem.StartDateDesc }} - {{ SemesterItem.EndDateDesc }})</p>
				</div>
			</ng-template>
		</p-listbox>
	</div>
</div>

<!--Buttons-->
<div class="Buttons ExtraTopMargin">
	<button class="btn btn-success" (click)="onUpdate()">Update Calendar</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin" style="margin-bottom: 150px">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
